import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
function Home5() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <h1>
            Tornar-se analista não é um marco de saída ou de chegada, não é um
            resultado e nem um ponto fixo; é uma travessia.
          </h1>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home5;
